<template>
  <div id="playable-card" class="w-48 h-72 p-2 m-2 border-2 flex flex-col">

  </div>

</template>

<script>

export default {
  name: "cq-card-placeholder",
}
</script>

